import { render, staticRenderFns } from "./tambahfoto.vue?vue&type=template&id=163a8a32&"
import script from "./tambahfoto.vue?vue&type=script&lang=js&"
export * from "./tambahfoto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports